import React, { EventHandler, HtmlHTMLAttributes, useCallback, useState } from "react";
import { UserActivityLevelBadge } from "../../pages/users/user-activity-level-badge.component";
import BootstrapTooltip from "../bootstrap-tooltip/bootstrap-tooltip";
import { TargetProcessLink } from "../target-process-link/target-process-link.component";
import { UserSlimModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import UserDetailsModal from "../../pages/users/user-details-modal/user-details-modal.component";
import { UserSlimDisplay } from "../user-slim-display/user-slim-display";
import { getPanelUsersClient } from "../../services/api-clients.service";

type UserByIdDisplayProps = {
    userId: string,
    showDetailsOnClick?: boolean,
    showDismiss?: boolean;
    onDissmissValue?: () => void;
};

export const UserByIdDisplay = ({ userId, showDetailsOnClick, showDismiss, onDissmissValue }: UserByIdDisplayProps) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [user, setUser] = React.useState<UserSlimModel>();

    React.useEffect(() => {
        if (!!userId) {
            getUserData();
        }
    }, [userId]);

    if (!userId)
        return null;

    if (isLoading)
        return <span>Loading...</span>;
    const getUserData = async () => {
        try {
            const client = getPanelUsersClient();
            const userResp = await client.getUserSlimDetails(userId);
            setUser(userResp);

        } catch (error) {

        } finally {
            setIsLoading(false);
        }

    }

    return <div style={{ display: "flex", gap: "5px", justifyContent: "space-between", width: "100%", paddingRight: "10px" }}>
        <UserSlimDisplay user={{ ...user } as UserSlimModel} showDetailsOnClick={showDetailsOnClick} />
        {showDismiss && <button className="ml-2" style={{
            backgroundColor: "transparent",
            border: "none",
            padding: "0",
            cursor: "pointer",
        }}
            onClick={() => { onDissmissValue?.(); }} aria-label="Close">
            <i className="fas fa-times"></i>
        </button>}
    </div>
}